import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  isGiftFlow: boolean;
  purchase: core.IPastPurchase;
  requestInProgress: boolean;
  transferPrice: number | null;
  transferToEmail: string | null;
}

const initialState: State = {
  isGiftFlow: false,
  purchase: {},
  requestInProgress: false,
  transferPrice: null,
  transferToEmail: null,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.TRANSFER_PURCHASE_UPDATE: {
      return {
        ...state,
        purchase: payload.purchase,
      };
    }
    case AppConstants.TRANSFER_TO_EMAIL_UPDATE: {
      return {
        ...state,
        transferToEmail: payload.transferToEmail,
      };
    }
    case AppConstants.TRANSFER_PRICE_UPDATE: {
      return {
        ...state,
        transferPrice: payload.transferPrice,
      };
    }
    case AppConstants.TRANSFER_INITIATE_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case AppConstants.TRANSFER_INITIATE_DONE:
    case AppConstants.TRANSFER_INITIATE_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case AppConstants.TRANSFER_CLEAR: {
      return {
        ...initialState,
      };
    }
    case AppConstants.TRANSFER_IS_GIFT_FLOW_UPDATE: {
      return {
        ...state,
        isGiftFlow: payload.isGiftFlow,
      };
    }
    default:
      return state;
  }
}
